export default __webpack_public_path__ + "2b5e70e6c0caa9fae7f4c40ae6c114aa.png";